/**
 * Whether the owning identity is a user or an organization per
 * developer-api.md §5.5.2. v1 always emits `USER`; org support
 * ships in v1.1+.
 *
 * Wire format: UPPERCASE matches the Kotlin `AccountType` enum.
 */
export const AccountType = {
    USER: 'USER',
    ORG: 'ORG',
};
